import React from "react";
import "./Footer.css";

import {
  FaGlobe,
  FaSprayCan,
  FaRegClock,
  FaHeart,
  FaInstagram,
  FaFacebookF,
  FaTiktok,
} from "react-icons/fa";

function Footer() {
  return (
    <footer className="footer">

      <div className="footer-container">

        <div className="footer-left">

          <span className="footer-small">
            OUR STORY
          </span>

          <h2>
            A SCENT THAT
            <br />
            CONNECTS US ALL.
          </h2>

          <p>
            SAH? is more than a fragrance.
            It's inspired by nations, memories
            and the passion we carry with us.
          </p>

        </div>

        <div className="footer-right">

          <div className="footer-feature">
            <FaGlobe className="footer-icon" />

            <h4>INSPIRED BY NATIONS</h4>

            <p>Every country. Every story.</p>
          </div>

          <div className="footer-feature">
            <FaSprayCan className="footer-icon" />

            <h4>SIGNATURE SCENTS</h4>

            <p>Every mood has a scent.</p>
          </div>

          <div className="footer-feature">
            <FaRegClock className="footer-icon" />

            <h4>LASTS UP TO 6 WEEKS</h4>

            <p>Premium long-lasting fragrance.</p>
          </div>

          <div className="footer-feature">
            <FaHeart className="footer-icon" />

            <h4>COLLECT THEM ALL</h4>

            <p>Build your SAH? collection.</p>
          </div>

        </div>

      </div>

      <div className="footer-bottom">

      <div className="footer-social">

  <a
    href="https://www.instagram.com/sahscent?igsh=NzM5Y3A2dmNhdDJy&utm_source=qr"
    target="_blank"
    rel="noreferrer"
  >
    <FaInstagram />
  </a>

  <a
    href="https://www.facebook.com/share/1DCcukNWtH/?mibextid=wwXIfr"
    target="_blank"
    rel="noreferrer"
  >
    <FaFacebookF />
  </a>

  <a
    href="https://www.tiktok.com/@sahscent?_r=1&_t=ZS-98PNq6afMGa"
    target="_blank"
    rel="noreferrer"
  >
    <FaTiktok />
  </a>

</div>
        <p>
          © 2026 SAH. All Rights Reserved.
        </p>

        <div className="footer-links">

          {/* <a href="/">Shipping & Returns</a> */}

          <a href="/faq">FAQ</a>

          <a href="/contact">Contact</a>

        </div>

      </div>

    </footer>
  );
}

export default Footer;